module.exports = __webpack_public_path__ + "img/مربع.4137d067.png";